import { render, staticRenderFns } from "./JapanMap.vue?vue&type=template&id=2c052ced&"
import script from "./JapanMap.vue?vue&type=script&lang=js&"
export * from "./JapanMap.vue?vue&type=script&lang=js&"
import style0 from "./JapanMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports